import { render, staticRenderFns } from "./MenuSidebarContent.vue?vue&type=template&id=b0a1785e&scoped=true&"
import script from "./MenuSidebarContent.vue?vue&type=script&lang=js&"
export * from "./MenuSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./MenuSidebarContent.vue?vue&type=style&index=0&id=b0a1785e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a1785e",
  null
  
)

export default component.exports